import * as React from 'react';
import {Container} from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';



export default function TableLayout(props:any) {
    const {t, isPrinting} =props
    const result = JSON.parse(localStorage.getItem("tum_leitfaden_result") as string) as any
    const input = JSON.parse(localStorage.getItem("tum_leitfaden_input") as string) as any
    const retrieveSpecificData = (columnName:string) =>{
        return result.find((data: any) => data.name === columnName)["value"]
    }

    function createData(
        column: string,
        unit: string,
        data: number,
    ) {
        let col = t(column)
        return { col,unit, data };
    }
    const divideData = (data:any, divider:any) =>{
        return (data/divider).toFixed(1).toString().replace(".",",")
    }

    const rows:any = result.length > 0 ? [
        createData('result_page.crown_diameter',"cm", retrieveSpecificData("dbh").toFixed(1).replace(".",",")),
        createData('result_page.tree_height',"m",retrieveSpecificData("height").toFixed(1).replace(".",",")),
        createData('result_page.crown_projection_area',"m" +String.fromCodePoint(0x00B2),retrieveSpecificData("CPA").toFixed(1).replace(".",",")),
        createData('result_page.crown_projection_increase',"m" +String.fromCodePoint(0x00B2) +"/"+  t('year'),retrieveSpecificData("inc CPA").toFixed(1).replace(".",",")),
        createData('result_page.biomass',"kg C", retrieveSpecificData("Bti").toFixed(0).replace(".",",")),
        createData('result_page.biomass_increase',"kg/" +  t('year'), retrieveSpecificData("inc bio").toFixed(1).replace(".",",")),
        createData('result_page.annual_growth_rate',"%", retrieveSpecificData("gr%").toFixed(1).replace(".",",")),
        createData('result_page.dryness_index',"", retrieveSpecificData("DI").toFixed(2).replace(".",",")),
        createData('result_page.water_use_efficiency', "g/kg H"+String.fromCodePoint(0x2082)+"0",divideData(retrieveSpecificData("inc bio") as any, result[63].value) as any),
    ] : [];
    return (
        <Container>
            <TableContainer component={Paper}>
                <Table sx={{ borderColor: "black", borderWidth: 4, minWidth: isPrinting ? 350 : 650, maxWidth: isPrinting ? 450: "100%" }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{lineHeight: isPrinting ? '1em': 'inherit'}} align="left">{t('result_page.parameter')}</TableCell>
                            <TableCell sx={{lineHeight: isPrinting ? '1em': 'inherit'}} align="center">{t('result_page.value')}</TableCell>
                            <TableCell sx={{lineHeight: isPrinting ? '1em': 'inherit'}} align="center">{t('result_page.unit')}</TableCell>
                            {/*{isPrinting ? null :<TableCell align="center">{t('unit')}</TableCell> }*/}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={{lineHeight: isPrinting ? '1em': 'inherit'}} align="left">{t('result_page.period')}</TableCell>
                            <TableCell sx={{lineHeight: isPrinting ? '1em': 'inherit'}} align="center">{input.period}</TableCell>
                            <TableCell sx={{lineHeight: isPrinting ? '1em': 'inherit'}} align="center">{""}</TableCell>
                        </TableRow>
                        {rows.map((row:any) => (
                            <TableRow
                                key={row.col as string}

                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell sx={{lineHeight: isPrinting ? '1em': 'inherit'}}  align="left" component="th" scope="row">
                                    {row.col as string}
                                </TableCell>
                                <TableCell sx={{lineHeight: isPrinting ? '1em': 'inherit'}}  align="center">{row.data}</TableCell>
                                <TableCell sx={{lineHeight: isPrinting ? '1em': 'inherit'}}  align="center">{row.unit}</TableCell>
                                {/*{isPrinting ? null :  <TableCell align="center">{row.unit}</TableCell>}*/}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    );
}
